<div class="query-running"><capra-icon icon="icon-refresh"></capra-icon></div>
